import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const useCurrencies = () => {
    return useQuery({
        queryKey: ["currencies"],
        queryFn: () => CommonService.getAllCurrencies().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};